var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutter" },
            [_c("back-button", { attrs: { returnUrl: "/security/-1" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end no-gutter" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mx-3",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchMode("view")
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mx-3",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.switchMode("edit")
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("administration.edit")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }